/*
 * Seaszn: password-page countdown clock.
 *
 * Usage: <seaszn-countdown data-target="2026-09-13T19:00:00+01:00">...</seaszn-countdown>
 * data-target must be a value `new Date()` can parse — the Liquid template
 * builds it from the block's date / time / UTC-offset settings so merchants
 * never have to touch this file to change the launch date.
 */
if (!customElements.get('seaszn-countdown')) {
  customElements.define(
    'seaszn-countdown',
    class SeasznCountdown extends HTMLElement {
      connectedCallback() {
        const targetAttr = this.getAttribute('data-target');
        this.target = targetAttr ? new Date(targetAttr) : null;

        this.digitsWrapper = this.querySelector('[data-countdown-digits]');
        this.expiredWrapper = this.querySelector('[data-countdown-expired]');
        this.daysEl = this.querySelector('[data-countdown-days]');
        this.hoursEl = this.querySelector('[data-countdown-hours]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        if (!this.target || isNaN(this.target.getTime())) return;

        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const diff = this.target.getTime() - Date.now();

        if (diff <= 0) {
          clearInterval(this.interval);
          if (this.digitsWrapper) this.digitsWrapper.hidden = true;
          if (this.expiredWrapper) this.expiredWrapper.hidden = false;
          this.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor(totalSeconds / 3600) % 24;
        const minutes = Math.floor(totalSeconds / 60) % 60;
        const seconds = totalSeconds % 60;

        this.setDigit(this.daysEl, days);
        this.setDigit(this.hoursEl, hours);
        this.setDigit(this.minutesEl, minutes);
        this.setDigit(this.secondsEl, seconds);
      }

      setDigit(el, value) {
        if (!el) return;
        el.textContent = value < 10 ? `0${value}` : `${value}`;
      }
    }
  );
}
